import { Text } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const LimitsListHeader = () => {
  const { t } = useTranslation('limitsEN');

  return (
    <div
      id='header-row'
      className='bg-surface-primary-bw-01 flex px-[24px] py-[12px] w-full h-[40px] rounded-tl-lg rounded-tr-lg'
    >
      <div className='w-[313px]' id='transaction-title'>
        <Text.H10 className='text-text-main-secondary'>{t('LIST_HEADER_TRANSACTION_TYPE')}</Text.H10>
      </div>
      <div className='w-[103px] flex justify-start' id='current-limit-title'>
        <Text.H10 className='text-text-main-secondary'>{t('LIST_HEADER_CURRENT_LIMIT')}</Text.H10>
      </div>
      <div className='w-[100px] flex justify-end' id='new-limit-title'>
        <Text.H10 className='text-text-main-secondary'>{t('LIST_HEADER_NEW_LIMIT')}</Text.H10>
      </div>
    </div>
  );
};
